module.exports = __webpack_public_path__ + "img/top-bg.0da91116.png";